import { Phone, Mail, Lock, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT } from "@/lib/siteData";

export const AtelierFooter = () => {
  return (
    <footer className="bg-[#14110E] text-[#FAF7F2] pt-20 pb-10 border-t border-[#FAF7F2]/10" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-[#FAF7F2]/10">
          <div className="lg:col-span-6">
            <p className="font-serif-display text-4xl sm:text-5xl font-light tracking-tight leading-tight">
              Louis Larsson
              <span className="block italic text-[#BFA574] text-2xl sm:text-3xl mt-2">
                Peinture & Rénovation
              </span>
            </p>
            <p className="mt-6 max-w-md text-sm font-light leading-relaxed text-[#FAF7F2]/55">
              Artisan du bâtiment — la rigueur du geste, la noblesse des
              matériaux, la confiance comme signature.
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-[#BFA574] mb-5">Contact direct</p>
            <a
              href={CONTACT.phoneHref}
              data-testid="footer-phone-link"
              className="flex items-center gap-2.5 text-sm text-[#FAF7F2]/80 hover:text-[#BFA574] transition-colors duration-300 mb-3"
            >
              <Phone className="w-4 h-4" /> {CONTACT.phoneDisplay}
            </a>
            <a
              href={CONTACT.emailHref}
              data-testid="footer-email-link"
              className="flex items-center gap-2.5 text-sm text-[#FAF7F2]/80 hover:text-[#BFA574] transition-colors duration-300 break-all"
            >
              <Mail className="w-4 h-4 shrink-0" /> {CONTACT.email}
            </a>
            <a
              href="https://www.facebook.com/llprlesmesnuls/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              className="flex items-center gap-2.5 text-sm text-[#FAF7F2]/80 hover:text-[#BFA574] transition-colors duration-300 mt-3"
            >
              <Facebook className="w-4 h-4 shrink-0" /> LLPR Les Mesnuls — Facebook
            </a>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-[#BFA574] mb-5">Mentions</p>
            <p className="font-mono-tech text-[11px] leading-loose text-[#FAF7F2]/50">
              SIRET 750 692 477 00011
              <br />
              Assurance décennale AXERIA — Attestation sur devis
              <br />
              {CONTACT.zone}
            </p>
          </div>
        </div>
        <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-mono-tech text-[11px] text-[#FAF7F2]/40">
            © {new Date().getFullYear()} Louis Larsson — Tous droits réservés
          </p>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="inline-flex items-center gap-2 font-mono-tech text-[11px] uppercase tracking-wider text-[#FAF7F2]/40 hover:text-[#BFA574] transition-colors duration-300"
          >
            <Lock className="w-3.5 h-3.5" /> Espace artisan
          </Link>
        </div>
      </div>
    </footer>
  );
};
